import { ModalHeader } from '@/components/Modal'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { useController } from '../hooks/useController'
import { useTexts } from '../hooks/useTexts'

export function Header() {
  const texts = useTexts()
  const {
    data: { depotIds },
    close,
  } = useController()

  return (
    <ModalHeader
      title={texts.title(depotIds.length)}
      actions={[
        <ActionBarItem
          icon={<Close />}
          testId="close-button"
          key="close"
          onClick={close}
          label=""
        />,
      ]}
    />
  )
}
